<!--eslint-disable vue/no-v-html-->
<template>
  <div
    v-if="sanitizedCustomHtml"
    class="custom-html-element"
    v-html="sanitizedCustomHtml"
  />
</template>

<script>
import DOMPurify from "dompurify";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import CustomHtml from "%/dynamic-component-editor/options/custom-html";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";

export default {
  name: "CustomHtmlElement",
  // Production twin: exempt from the palette's elementPanelSettings gate.
  production: true,
  mixins: [DynamicElementMixin],
  elementPanelSettings: {
    displayName: "Custom HTML",
    displayIcon: "code",
    elementGroup: "general",
    elementType: "element",
  },
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.layout-width": "fill",
      "default.layout-height": "hug",
    }),
    SpacingOptions,
  ],
  options: [
    CustomHtml,
  ],
  computed: {
    sanitizedCustomHtml() {
      const customHtml = this.getOptionValue(CustomHtml);
      return DOMPurify.sanitize(customHtml || "", { ADD_TAGS: ["svg", "use"] });
    },
  },
};
</script>

<style scoped lang="scss">
.custom-html-element {
  width: 100%;
  height: 100%;
}
</style>
